import { useEffect, useState } from "react";
import { Server } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

const ago = (iso) => (iso ? Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000)) : null);

const Instance = ({ i, n }) => {
  const { t, fmtDate } = useI18n();
  return (
    <li className="min-w-0 border-b border-white/5 py-2 text-sm last:border-0" data-testid={`health-instance-${n}`}>
      <p className="flex min-w-0 items-center gap-2 text-neutral-100">
        <span className="h-2 w-2 shrink-0 rounded-full bg-emerald-400" aria-hidden />
        <bdi className="min-w-0 truncate font-mono text-xs" title={i.id}>{i.id}</bdi>
        {i.me && <span className="rounded-full bg-sky-500/20 px-2 py-0.5 text-[10px] font-semibold text-sky-200">{t("heal.inst.me")}</span>}
      </p>
      <p className="mt-1 text-xs text-neutral-400">
        <bdi>{t("heal.inst.since")} {i.started ? fmtDate(i.started) : "—"}</bdi> · <bdi>{t("heal.inst.beat", { s: ago(i.at) ?? "—" })}</bdi>
      </p>
      <p className="mt-1 flex flex-wrap gap-1" data-testid={`health-instance-roles-${n}`}>
        {i.roles.length ? i.roles.map((r) => <span key={r} className="rounded bg-[rgba(245,197,66,0.12)] px-1.5 py-0.5 text-[10px] text-[var(--gold-bright)]">{r.replace("worker:", "")}</span>)
          : <span className="text-[10px] text-neutral-500">{t("heal.inst.noRole")}</span>}
      </p>
    </li>
  );
};

export const InstancesCard = () => {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/selfheal/instances").then(({ data }) => setD(data)).catch(() => {});
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);
  if (!d) return null;
  return (
    <section className="card-carbon min-w-0 rounded-2xl p-5" data-testid="health-instances">
      <h2 className="flex items-center gap-2 font-display text-base font-bold text-white md:text-lg"><Server className="h-4 w-4 text-[var(--gold)]" /> {t("heal.inst.title", { n: d.instances.length })}</h2>
      <p className="mt-1 text-xs text-neutral-400">{t("heal.inst.hint")}</p>
      <ul className="mt-2">{d.instances.map((i, n) => <Instance key={i.id} i={i} n={n} />)}</ul>
    </section>
  );
};
